export default __webpack_public_path__ + "static/media/PayrollActiveIcon.8ff11ced.svg";